import { ITrendingNewsResponse } from "@/types/trending-news.type";
import { BASE_URL, STRAPI_HEADERS } from "./strapi-config";

export const getTrendingNews = (
  locale: string
): Promise<ITrendingNewsResponse> => {
  return fetch(
    `${BASE_URL}/trending-news?locale=${encodeURIComponent(locale)}&populate[0]=new&populate[1]=new.poster&sort[0]=priority_order`,
    STRAPI_HEADERS
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data: ITrendingNewsResponse) => {
      return data;
    });
};
